module.exports = __webpack_public_path__ + "static/media/behold.a9bdad8c.svg";